"use strict";

import { Box, Heading, Stack } from '@autoguru/overdrive';
import clsx from 'clsx';
import * as styles from './BoxedMessageScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BoxedMessageScreen = ({
  title,
  children,
  className: _className = '',
  imgUrl,
  illustration,
  boxed: _boxed = true
}) => /*#__PURE__*/_jsx(Box, {
  "aria-disabled": "true",
  borderWidth: _boxed ? '1' : 'none',
  borderRadius: "md",
  borderColour: "light",
  paddingY: ['2', '3'],
  paddingX: ['2', '3'],
  className: clsx(styles.root, _className),
  children: /*#__PURE__*/_jsxs(Stack, {
    width: "full",
    space: "2",
    alignItems: "center",
    children: [imgUrl && /*#__PURE__*/_jsx("img", {
      className: styles.successImage,
      src: imgUrl,
      alt: "Success"
    }), illustration, /*#__PURE__*/_jsxs(Stack, {
      width: "full",
      space: "5",
      children: [title ? /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        children: title
      }) : null, children]
    })]
  })
});